/**
 * Sidebar Mobile do Sistema MEDICARE
 * Navegação lateral para dispositivos móveis
 */

import React from 'react';
import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useColorModeValue,
} from '@chakra-ui/react';
import { Sidebar } from './Sidebar';

interface MobileSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileSidebar: React.FC<MobileSidebarProps> = ({ isOpen, onClose }) => {
  return (
    <Drawer
      autoFocus={false}
      isOpen={isOpen}
      placement="left"
      onClose={onClose}
      returnFocusOnClose={false}
      onOverlayClick={onClose}
      size="full"
    >
      <DrawerOverlay />
      <DrawerContent>
        <Sidebar onClose={onClose} />
      </DrawerContent>
    </Drawer>
  );
};

export default MobileSidebar;